import {Chip} from "./Chip";

export const FirstPartyChip = () => {
  return <Chip label={"First Party"} variant_={"blue"} size_={"small"} border />;
};
